import { COLORS } from "@/lib/photoEdit";

export const ColorRow = ({ value, onChange, testid = "photo-color" }) => (
  <div className="flex items-center justify-center gap-3" data-testid={`${testid}-row`}>
    {COLORS.map((c) => (
      <button
        key={c}
        type="button"
        data-testid={`${testid}-${c.slice(1)}`}
        aria-label={`Colour ${c}`}
        onClick={() => onChange(c)}
        style={{ backgroundColor: c }}
        className={`h-7 w-7 rounded-full border-2 transition-transform active:scale-90 ${value === c ? "border-white scale-110 ring-2 ring-[#3B82F6]" : "border-white/40"}`}
      />
    ))}
  </div>
);
